import { useEffect, useRef } from "react";
import { postOpenedActivity } from "./activity-client.js";

function forgetPortalMarker() {
  const url = new URL(window.location.href);
  if (url.searchParams.get("entry") !== "portal") return;
  url.searchParams.delete("entry");
  window.history.replaceState(
    window.history.state,
    "",
    `${url.pathname}${url.search}${url.hash}`,
  );
}

export function useActivityTracking({
  apiUrl,
  getAccessToken,
  appId,
  toolId = null,
  enabled = true,
  portalEntry = false,
  scopeKey = "default",
}) {
  const openedApps = useRef(new Set());
  const openedPortals = useRef(new Set());
  const previousTool = useRef({ scopeKey: null, toolId: null });

  useEffect(() => {
    if (!enabled || openedApps.current.has(scopeKey)) return;
    openedApps.current.add(scopeKey);
    void postOpenedActivity({
      apiUrl,
      getAccessToken,
      action: "app_opened",
      appId,
    }).catch(() => {});
  }, [apiUrl, appId, enabled, getAccessToken, scopeKey]);

  useEffect(() => {
    if (!enabled || !portalEntry || openedPortals.current.has(scopeKey)) return;
    openedPortals.current.add(scopeKey);
    void postOpenedActivity({
      apiUrl,
      getAccessToken,
      action: "portal_opened",
      appId: "account",
      payload: { entryPoint: "website_portal" },
    }).catch(() => {});
    forgetPortalMarker();
  }, [apiUrl, enabled, getAccessToken, portalEntry, scopeKey]);

  useEffect(() => {
    if (!enabled || !toolId) {
      if (previousTool.current.scopeKey === scopeKey) {
        previousTool.current = { scopeKey, toolId: null };
      }
      return;
    }
    if (
      previousTool.current.scopeKey === scopeKey
      && previousTool.current.toolId === toolId
    ) return;
    previousTool.current = { scopeKey, toolId };
    void postOpenedActivity({
      apiUrl,
      getAccessToken,
      action: "tool_opened",
      appId,
      toolId,
    }).catch(() => {});
  }, [apiUrl, appId, enabled, getAccessToken, scopeKey, toolId]);
}
